import { Button } from '@storeblocks/button';
import { type FC } from 'react';

import { useTexts } from '@/hooks/useTexts';
import { TrackingElement, useGetTrackId } from '@/tracking';

interface Props {
  onClick: () => void;
}

export const AddDualCitizenshipButton: FC<Props> = ({ onClick }) => {
  const texts = useTexts();
  const getTrackId = useGetTrackId();

  return (
    <div>
      <Button
        data-test="add-dual-citizenship"
        variant="tertiary"
        iconLeft="add"
        onClick={onClick}
        data-trackid={getTrackId(
          'add-dual-citizenship',
          TrackingElement.Button,
        )}
      >
        {texts.orders.signatureRight.pep.citizenship.addDual}
      </Button>
    </div>
  );
};
